import type { ComponentProps, ReactNode } from "react";

import { cn } from "../../lib/utils.ts";
import { Drawer, DrawerContent } from "./drawer.tsx";

type ContentBottomSheetProps = {
    children: ReactNode;
    title: ReactNode;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    finalFocus?: ComponentProps<typeof DrawerContent>["finalFocus"];
    bodyClassName?: string;
};

function ContentBottomSheet({
    children,
    title,
    open,
    onOpenChange,
    finalFocus,
    bodyClassName,
}: ContentBottomSheetProps) {
    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            <DrawerContent
                title={title}
                finalFocus={finalFocus}
                className="min-h-[30dvh] max-h-[85dvh]"
            >
                <div className="flex min-h-0 w-full flex-auto flex-col overflow-hidden">
                    <div className="flex items-center justify-center px-4 pb-3">
                        <h3 className="text-body text-doberman-black">
                            {title}
                        </h3>
                    </div>

                    <div
                        className={cn(
                            "min-h-0 flex-auto overflow-y-auto px-6 pb-[calc(env(safe-area-inset-bottom)+24px)]",
                            bodyClassName,
                        )}
                    >
                        {children}
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

export { ContentBottomSheet };
